import allCarriers from '../../tracking-mapping-v2/static/carriers'

const LEGACY_CARRIER_VALUES = ['DHLeCommerce', 'USPS', 'UPS', 'Multrans', 'Australia Post']

const carriers = allCarriers.filter((carrier) => LEGACY_CARRIER_VALUES.includes(carrier.value))

export default carriers
